/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonCompanySerie,
    JsonCompanySerieFromJSON,
    JsonCompanySerieFromJSONTyped,
    JsonCompanySerieToJSON,
} from './JsonCompanySerie';

/**
 * 
 * @export
 * @interface ApiResultOfJsonCompanySerie
 */
export interface ApiResultOfJsonCompanySerie {
    /**
     * 
     * @type {JsonCompanySerie}
     * @memberof ApiResultOfJsonCompanySerie
     */
    data?: JsonCompanySerie;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonCompanySerie
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonCompanySerie
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonCompanySerie
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonCompanySerie
     */
    result?: ApiResultOfJsonCompanySerieResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonCompanySerieResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonCompanySerieFromJSON(json: any): ApiResultOfJsonCompanySerie {
    return ApiResultOfJsonCompanySerieFromJSONTyped(json, false);
}

export function ApiResultOfJsonCompanySerieFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonCompanySerie {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonCompanySerieFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonCompanySerieToJSON(value?: ApiResultOfJsonCompanySerie | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonCompanySerieToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

